import {
  MinusCircleOutlined,
  PlusOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  Form,
  message,
  Modal,
  Row,
  Select,
  Space,
  Input,
  Checkbox,
} from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import AutoOpenSelect from '../../SelectComponent/AutoOpenSelect';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import initialTermsCondition from '../../../Common/intialTermsCondition';
import { ReactComponent as Back } from '../../../Images/Back.svg';
import {
  fetchAlloyDropdown,
  resetAlloyList,
  resetCurrentAlloyListPage,
} from '../../../slices/alloy';
import {
  fetchTemperDropdown,
  resetCurrentTemperPage,
  resetTempersList,
} from '../../../slices/tempers';
import {
  createQuickCustomer,
  fetchCustomerConversionList,
  fetchCustomerDropdown,
  resetCurrentCustomerPage,
  resetCustomerList,
} from './../../../slices/customer';
import {
  fetchDieProfileById,
  fetchDieProfileList,
  fetchDieProfileDropdown,
  resetCurrentDieProfilePage,
  resetDieProfileList,
  resetDieProfileData,
} from './../../../slices/die-profile';
import { createQuotation } from '../../../slices/quotation';
import {
  fetchConversionRateList,
  resetConversionRateList,
} from '../../../slices/conversion-rate';
import { fetchNalcoRateForQuotation } from '../../../slices/nalco-rate';
import { createNumberValidationRule } from '../../../utils/CreateNumberValidationRule';
import { debounce } from 'lodash';
import { fetchjobWorkList, resetJobWorkList } from '../../../slices/job-work';

const { Option } = Select;

export default function CreateInquiryQuotation() {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const [editorValue, setEditorValue] = useState(initialTermsCondition);
  const [customerForm] = Form.useForm();
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchTemper, setSearchTemper] = useState('');
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [searchAlloy, setSearchAlloy] = useState('');
  const [isCustomerModalVisible, setIsCustomerModalVisible] = useState(false);
  const [searchCustomer, setSearchCustomer] = useState('');
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const { list: customerList } = useSelector(state => state.customer);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedEngineeringOptions, setSelectedEngineeringOptions] = useState(
    {},
  );
  const [selectedSurfaceFinish, setSelectedSurfaceFinish] = useState('');
  const [selectedJobWork, setSelectedJobWork] = useState('');
  const [hasErrors, setHasErrors] = useState(false);
  const {
    list: dieProfileList,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const {
    list: alloyList,
    loading: alloyLoading,
    currentPage: alloyCurrentPage,
    hasMore: alloyHasMore,
  } = useSelector(state => state.alloy);
  const {
    jobWorklist,
    loading: jobWorkLoading,
  } = useSelector(state => state.jobWork);
  const {
    list: temperList,
    loading: temperLoading,
    hasMore: temperHasMore,
  } = useSelector(state => state.temper);
  const [pricePerKg, setPricePerKg] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(
          fetchNalcoRateForQuotation(),
        );
        if (response) {
          setPricePerKg(response.payload.data.rate);
          form.setFieldsValue({
            quotation_details: [
              {
                price_per_kg: response.payload.data.rate,
              },
            ],
          });
        } else {
          console.error('Unexpected response structure:', response);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (selectedIndex === null) return;
    const workOrderDetails = form.getFieldValue('quotation_details') || [];
    const updatedDetails = [...workOrderDetails];
    const item = updatedDetails[selectedIndex];

    if (item) {
      const currentKg = item.wt_kg_p_mt || 0;
      const length = parseFloat(item.length) || 0;
      const pieces = parseFloat(item.pieces) || 0;
      const netWeight = ((currentKg * length) / 1000) * pieces;
      const toleranceValue = form.getFieldValue('tolerance') || '';
      const tolerancePercent = toleranceValue
        ? parseFloat(toleranceValue.replace(/[^\d.]/g, '')) || 0
        : 0;
      const isPositive = toleranceValue.includes('+');
      const isNegative = toleranceValue.includes('-');
      let max_weight = netWeight;
      let min_weight = netWeight;

      if (tolerancePercent > 0) {
        if (isPositive && isNegative) {
          max_weight = netWeight * (1 + tolerancePercent / 100);
          min_weight = netWeight * (1 - tolerancePercent / 100);
        } else if (isPositive) {
          max_weight = netWeight * (1 + tolerancePercent / 100);
          min_weight = netWeight;
        } else if (isNegative) {
          min_weight = netWeight * (1 - tolerancePercent / 100);
          max_weight = netWeight;
        }
      }
      updatedDetails[selectedIndex] = {
        ...item,
        net_weight: netWeight.toFixed(2),
      };
      form.setFieldsValue({
        quotation_details: updatedDetails,
      });
    }
  }, [selectedIndex, form]);

  useEffect(() => {
     dispatch(resetJobWorkList());
    dispatch(resetTempersList());
    dispatch(resetDieProfileList());
    dispatch(resetDieProfileData());
    dispatch(resetCustomerList());
    dispatch(resetAlloyList());
    dispatch(resetConversionRateList());
    dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchTemperDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchConversionRateList({ page: 1, pagesize: 1000 }));
    dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchjobWorkList());
   
  }, [dispatch, page, pagesize]);

  const handleFieldChange = (index, changedField) => {
    const workOrderDetails = form.getFieldValue('quotation_details') || [];
    const row = { ...workOrderDetails[index] } || {};
    const currentKg = row?.wt_kg_p_mt || 0;
    const length = parseFloat(row.length) || 0;
    const pieces = parseFloat(row.pieces) || 0;
    const net_weight = parseFloat(row.net_weight) || 0;

    let calculatedNetWeight = net_weight;
    let calculatedPieces = pieces;

    if (
      changedField === 'net_weight' &&
      net_weight > 0 &&
      length > 0 &&
      currentKg > 0
    ) {
      calculatedPieces = net_weight / (currentKg * (length / 1000));
    } else if (
      (changedField === 'pieces' || changedField === 'length') &&
      pieces > 0 &&
      length > 0 &&
      currentKg > 0
    ) {
      calculatedNetWeight = ((currentKg * length) / 1000) * pieces;
      calculatedNetWeight = Number(calculatedNetWeight).toFixed(3);
    }

    const updatedWorkOrderDetails = [...workOrderDetails];
    const updatedRow = {
      ...row,
      net_weight: calculatedNetWeight,
      wt_kg_p_mt: currentKg,
    };

    if (changedField === 'net_weight' || changedField === 'length') {
      updatedRow.pieces = Math.round(calculatedPieces);
    }

    updatedWorkOrderDetails[index] = updatedRow;
    form.setFieldsValue({
      quotation_details: updatedWorkOrderDetails,
    });
  };

  const handleSearchCustomer = value => {
    setSearchCustomer(value);
    if (value) {
      dispatch(resetCustomerList());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchCustomer('');
      dispatch(resetCustomerList());
      dispatch(resetCurrentCustomerPage());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const handleChangeCustomer = value => {
    setSearchCustomer(value);
  };

  const fetchConversionData = async (customerId, dieId, index) => {
    try {
      const response = await dispatch(
        fetchCustomerConversionList({
          page: 1,
          pagesize: 10,
          customer_id: customerId,
          die_id: dieId,
        }),
      );

      const updatedQuotationDetails = [
        ...form.getFieldValue('quotation_details'),
      ];

      if (response && response.payload.data.length > 0) {
        const conversionValue = response.payload.data[0].conversion;
        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          conversion: conversionValue,
          price_per_kg: pricePerKg,
        };
      } else {
        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          conversion: '',
          price_per_kg: pricePerKg,
        };
      }

      form.setFieldsValue({ quotation_details: updatedQuotationDetails });
    } catch (error) {
      console.error('Error fetching conversion data:', error);
    }
  };

  const handleChange = value => {
    setEditorValue(value);
  };

  const showCustomerModal = () => {
    setIsCustomerModalVisible(true);
  };

  const handleCustomerModalCancel = () => {
    setIsCustomerModalVisible(false);
    customerForm.resetFields();
  };

  const handleSaveCustomer = values => {
    dispatch(createQuickCustomer({ values }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Customer Created Successfully!');
          handleCustomerModalCancel();
          dispatch(fetchCustomerDropdown({ page, pagesize }));
        }
      })
      .catch(error => {
        console.error('Error saving customer:', error);
      });
  };

  const handleSurfaceFinishChange = (value, rowIndex) => {
    setSelectedSurfaceFinish(prev => ({
      ...prev,
      [rowIndex]: value,
    }));
  };

  const handleDieProfileChange = async (value, index) => {
    const updatedQuotationDetails = [
      ...form.getFieldValue('quotation_details'),
    ];
    updatedQuotationDetails[index] = {
      ...updatedQuotationDetails[index],
      die_profile: value?.value,
      conversion: '',
      customer_reference_no: '',
      wt_kg_p_mt: '',
    };
    form.setFieldsValue({ quotation_details: updatedQuotationDetails });
    setSelectedIndex(index);

    try {
      const response = await dispatch(
        fetchDieProfileById(value?.value),
      ).unwrap();
      if (response?.results?.data?.length > 0) {
        const customerRefNo =
          response.results.data[0]?.customer_reference_number || '';
        const wtKgPerMt = response.results.data[0]?.wt_kg_p_mt || '';

        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          customer_reference_no: customerRefNo,
          wt_kg_p_mt: wtKgPerMt,
        };

        form.setFieldsValue({
          quotation_details: updatedQuotationDetails,
        });

        const customerId = form.getFieldValue('customer');
        if (customerId) {
          await fetchConversionData(customerId, value?.value, index);
        }
      }
    } catch (error) {
      console.error('Error fetching customer reference number:', error);
    }
  };

  const debouncedSearchDieProfile = debounce((value, dispatch) => {
    dispatch(resetDieProfileData());
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50,
        search: value || '',
      }),
    );
  }, 300);

  const handleSearchDieProfile = value => {
    setSearchDieProfile(value);
    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };

  const onScrollDieProfile = event => {
    const target = event.target;
    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;
      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };

  const handleSearchAlloy = value => {
    setSearchAlloy(value);
    if (value) {
      dispatch(resetAlloyList());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchAlloy('');
      dispatch(resetAlloyList());
      dispatch(resetCurrentAlloyListPage());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const [searchUnitOfMeasurement, setSearchUnitOfMeasurement] = useState('');
  const handleChangeUnitOfMeasurement = value => {
    setSearchUnitOfMeasurement(value);
  };

  const handleSearchUnitOfMeasurement = value => {
    setSearchUnitOfMeasurement(value);
  };

  const onScrollAlloy = async event => {
    const target = event.target;
    if (
      !alloyLoading &&
      alloyHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchAlloyDropdown({ page: alloyCurrentPage, pagesize: 10 }));
    }
  };

  const handleSearchTemer = value => {
    setSearchTemper(value);
    if (value) {
      dispatch(resetTempersList());
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchTemper('');
      dispatch(resetTempersList());
      dispatch(resetCurrentTemperPage());
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const onScrollTemper = async event => {
    const target = event.target;
    if (
      !temperLoading &&
      temperHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchTemperDropdown({ page: alloyCurrentPage, pagesize: 10 }));
    }
  };

  const handleJobWorkChange = (value, rowIndex) => {
    const updatedWorkOrderDetails = [...form.getFieldValue('quotation_details'),];

    const currentRow = updatedWorkOrderDetails[rowIndex] || {};
    const jobWorkIdToName = Object.fromEntries(jobWorklist.map(item => [item.id, item.name]));
    const selectedNames = value.map(id => jobWorkIdToName[id]);
    updatedWorkOrderDetails[rowIndex] = {
      ...currentRow,
      jobworks: value,
    };

    if (selectedNames.includes('Engineering')) {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        cutting: currentRow.cutting || false,
        machinings: currentRow.machinings || false,
        deburring: currentRow.deburring || false,
        cutting_price: currentRow.cutting_price || undefined,
        machinings_price: currentRow.machinings_price || undefined,
        deburring_price: currentRow.deburring_price || undefined,
      };
    } else {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        cutting: false,
        machinings: false,
        deburring: false,
        cutting_price: undefined,
        machinings_price: undefined,
        deburring_price: undefined,
      };
      setSelectedEngineeringOptions(prev => ({
        ...prev,
        [rowIndex]: [],
      }));
    }

    if (selectedNames.includes('Laser marking')) {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        laser_marking_description:
          currentRow.laser_marking_description || undefined,
        laser_marking_price: currentRow.laser_marking_price || undefined,
      };
    } else {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        laser_marking_description: undefined,
        laser_marking_price: undefined,
      };
    }

    if (selectedNames.includes('Surface treatment')) {
      const surfaceFinishArray = [];
      if (currentRow.anodising) surfaceFinishArray.push('anodising');
      if (currentRow.powder_coating) surfaceFinishArray.push('powder_coating');
      if (currentRow.pvdf) surfaceFinishArray.push('pvdf');

      setSelectedSurfaceFinish(prev => ({
        ...prev,
        [rowIndex]: surfaceFinishArray,
      }));

      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        anodising: currentRow.anodising || false,
        powder_coating: currentRow.powder_coating || false,
        pvdf: currentRow.pvdf || false,
        anodising_description: currentRow.anodising_description || undefined,
        anodising_price: currentRow.anodising_price || undefined,
        powder_coating_description:
          currentRow.powder_coating_description || undefined,
        powder_coating_price: currentRow.powder_coating_price || undefined,
        pvdf_description: currentRow.pvdf_description || undefined,
        pvdf_price: currentRow.pvdf_price || undefined,
      };
    } else {
      setSelectedSurfaceFinish(prev => ({
        ...prev,
        [rowIndex]: [],
      }));

      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        anodising: false,
        powder_coating: false,
        pvdf: false,
        anodising_description: undefined,
        anodising_price: undefined,
        powder_coating_description: undefined,
        powder_coating_price: undefined,
        pvdf_description: undefined,
        pvdf_price: undefined,
      };
    }

    if (selectedNames.includes('Laser marking')) {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        laser_marking_description:
          currentRow.laser_marking_description || undefined,
        laser_marking_price: currentRow.laser_marking_price || undefined,
      };
    } else {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        laser_marking_description: undefined,
        laser_marking_price: undefined,
      };
    }

    if (!selectedNames.includes('Out Source')) {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        out_source: null,
      };
    } else {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        out_source: currentRow.out_source !== undefined ? currentRow.out_source : false,
      };
    }

    form.setFieldsValue({
      quotation_details: updatedWorkOrderDetails,
    });

    setSelectedJobWork(prev => ({
      ...prev,
      [rowIndex]: selectedNames,
    }));
  };
  const handleCheckboxJobWorkChange = (field, checked, rowIndex) => {
    const updatedWorkOrderDetails = [
      ...form.getFieldValue('quotation_details'),
    ];

    if (['cutting', 'machinings', 'deburring'].includes(field)) {
      setSelectedEngineeringOptions(prev => {
        const prevSelected = prev[rowIndex] || [];
        let newSelected;
        if (checked) {
          newSelected = [...prevSelected, field];
        } else {
          newSelected = prevSelected.filter(f => f !== field);
        }
        return {
          ...prev,
          [rowIndex]: newSelected,
        };
      });
    }

    if (['anodising', 'powder_coating', 'pvdf'].includes(field)) {
      setSelectedSurfaceFinish(prev => {
        const prevSelected = prev[rowIndex] || [];
        let newSelected;
        if (checked) {
          newSelected = [...prevSelected, field];
        } else {
          newSelected = prevSelected.filter(f => f !== field);
        }
        return {
          ...prev,
          [rowIndex]: newSelected,
        };
      });
    }

    updatedWorkOrderDetails[rowIndex] = {
      ...updatedWorkOrderDetails[rowIndex],
      [field]: checked,
    };

    form.setFieldsValue({
      quotation_details: updatedWorkOrderDetails,
    });
  };

  useEffect(() => {
    fetchAlloyDropdown();
    fetchTemperDropdown();
    fetchDieProfileList();
    fetchConversionRateList();
    resetAlloyList();
    resetTempersList();
    resetCurrentDieProfilePage();
    resetDieProfileList();
    resetConversionRateList();
  }, []);

  const handleFinish = values => {
    setBtnLoading(true);
    const updatedWorkOrderDetails = values.quotation_details.map(
      ({ wt_kg_p_mt, jobworks, out_source, ...item }) => {
        const detail = {
          ...item,
          pieces: parseFloat(item.pieces) || null,
          length: parseFloat(item.length) || null,
          net_weight: parseFloat(item.net_weight) || null,
          jobworks: Array.isArray(jobworks) ? jobworks : [],
          price_per_kg: parseFloat(item.price_per_kg) || null,
          conversion: parseFloat(item.conversion) || null,
          cutting: item?.cutting || false,
          machinings: item?.machinings || false,
          anodising: item?.anodising || false,
          powder_coating: item?.powder_coating || false,
          pvdf: item?.pvdf || false,
          surface_finish: item.surface_finish,
        };
        if (jobworks?.includes(4) && out_source != null) {
          detail.out_source = out_source;
        }

        return detail;
      },
    );
    const formattedValues = {
      ...values,
      quotation_details: updatedWorkOrderDetails,
    };
    values = formattedValues;
    values.quotation_date = dayjs(values.quotation_date).format('YYYY-MM-DD');
    dispatch(createQuotation({ values }))
      .unwrap()
      .then(result => {
        if (result.success) {
          setBtnLoading(false);
          setHasErrors(false);
          message.success('Quotation Created Successfully!');
          navigate('/quotation-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        setHasErrors(true);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const handleCompanyNameChange = async value => {
    form.setFieldValue('customer', value);
    form.validateFields(['customer']);
    handleChangeCustomer(value);

    const quotationDetails = form.getFieldValue('quotation_details') || [];
    const updatedQuotationDetails = [...quotationDetails];
    updatedQuotationDetails.forEach((item, index) => {
      updatedQuotationDetails[index] = {
        ...item,
        conversion: '',
      };
    });

    form.setFieldsValue({ quotation_details: updatedQuotationDetails });
    for (let i = 0; i < updatedQuotationDetails.length; i++) {
      const dieId = updatedQuotationDetails[i]?.die_profile;
      if (dieId) {
        await fetchConversionData(value, dieId, i);
      }
    }
  };

  const [packingMode, setPackingMode] = useState(false);
  const [packingModes, setPackingModes] = useState([
    { title: 'Strech Film', value: 'Strech Film' },
    { title: 'HDPE Packing', value: 'HDPE Packing' },
    { title: 'Inter Leaving', value: 'Inter Leaving' },
    { title: 'Bubble Wrap', value: 'Bubble Wrap' },
    { title: 'Corrugated Box', value: 'Corrugated Box' },
    { title: 'Wooden Box', value: 'Wooden Box' },
    { title: 'Other', value: 'Other' },
  ]);

  const handleChangePackingMode = e => {
    setPackingMode(e);
  };

  return (
    <>
      <div
        style={{
          position: 'sticky',
          zIndex: '1000',
          background: '#fff',
          padding: '16px',
          top: 0,
        }}
      >
        <div className="pagenamerow">
          <h2>Create Inquiry Quotation</h2>
          <div className="bredcrumbwrp">
            <Link to="/inquiry-quotation-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/inquiry-quotation-list">Quotations</Link> },
                { title: 'Create Inquiry' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          initialValues={{
            customer: null,
            quotation_date: dayjs(),
            remarks: null,
            terms_and_condition: '',
            packing_type: [],
            quotation_details: [
              {
                die_profile: '',
                customer_reference_no: '',
                wt_kg_p_mt: '',
                alloy: '',
                temper: '',
                length: null,
                jobworks: null,
                conversion: null,
                out_source: null,
                finishing_price: null,
                price_per_kg: pricePerKg,
                unit_of_measurement: '',
                description: '',
                surface_treatment: '',
                surface_finish: '',
                net_weight: null,
                pieces: null,
              },
            ],
          }}
        >
          <div className="formrowsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="customer"
                  label="Customer Name"
                  rules={[
                    { required: true, message: 'Please select company name' },
                  ]}
                >
                  <Space.Compact style={{ width: '100%' }}>
                    <AutoOpenSelect
                      value={searchCustomer}
                      placeholder="Please Select Company Name"
                      style={{ width: 'calc(100% - 40px)' }}
                      onChange={handleCompanyNameChange}
                      showSearch={true}
                      onSearch={handleSearchCustomer}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          customerList.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option
                          key={el.id}
                          value={el.id}
                          disabled={el.deleted === 1}
                        >
                          {el.customer_name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Space.Compact>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="quotation_date"
                  label="Today Date"
                  rules={[
                    { required: true, message: 'Please select quotation date' },
                  ]}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    disabled
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="packing_type"
                  label="Mode Of Packing"
                  rules={[
                    { required: true, message: 'Please select packing mode' },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Mode Of Packing"
                    onChange={handleChangePackingMode}
                    options={packingModes}
                    allowClear
                    mode="multiple"
                  />
                </Form.Item>
                {packingMode == 'Other' && (
                  <Form.Item
                    label="Other Packing Mode"
                    name="other_packing_mode"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter other packing mode',
                      },
                    ]}
                  >
                    <Input
                      style={{ marginTop: '8px' }}
                      placeholder="Please enter other packing mode"
                    />
                  </Form.Item>
                )}
              </Col>
            </Row>
          </div>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="quotation_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      className="rowItem mx-0"
                      gutter={[24, 24]}
                      align="middle"
                      key={key}
                      style={{ width: '100%' }}
                    >
                      <Col flex="auto">
                        <Row gutter={16}>
                          <Col xs={12} sm={8} xl={6}>
                            <Form.Item
                              {...restField}
                              name={[name, 'die_profile']}
                              label="Profile Number"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select a profile number',
                                },
                              ]}
                              style={{ marginBottom: 0 }}
                            >
                              <AutoOpenSelect
                                placeholder="Select Profile Number"
                                labelInValue
                                value={
                                  form.getFieldValue([
                                    'quotation_details',
                                    name,
                                    'die_profile',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'die_profile',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  handleDieProfileChange(value, name)
                                }
                                onSearch={handleSearchDieProfile}
                                allowClear
                                onClear={() => {
                                  dispatch(resetDieProfileData());
                                  dispatch(
                                    fetchDieProfileDropdown({
                                      page: 1,
                                      pagesize: 100,
                                    }),
                                  );
                                }}
                                showSearch={true}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                loading={dieProfileLoading}
                                onPopupScroll={onScrollDieProfile}
                                notFoundContent={
                                  dieProfileLoading
                                    ? 'Loading...'
                                    : 'No options'
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {[
                                  ...new Map(
                                    dieProfileList.map(item => [item.id, item]),
                                  ).values(),
                                ].map((el, index) => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.die_number}
                                  </Option>
                                ))}
                              </AutoOpenSelect>
                            </Form.Item>
                            {form.getFieldValue([
                              'quotation_details',
                              name,
                              'customer_reference_no',
                            ]) && (
                                <div
                                  style={{
                                    marginTop: '4px',
                                    marginBottom: '16px',
                                    paddingLeft: '0px',
                                  }}
                                >
                                  <span style={{ fontSize: '12px', color: '#666' }}>
                                    <b>Customer Ref No:</b>{' '}
                                    <span style={{ color: '#333' }}>
                                      {form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'customer_reference_no',
                                      ])}
                                    </span>
                                  </span>
                                </div>
                              )}
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'alloy']}
                              label="Alloy"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select alloy',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Alloy"
                                loading={alloyLoading}
                                onPopupScroll={onScrollAlloy}
                                notFoundContent={
                                  alloyLoading ? 'Loading...' : 'No options'
                                }
                                value={
                                  form.getFieldValue([
                                    'quotation_details',
                                    name,
                                    'alloy',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'alloy',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  form.setFieldValue(
                                    ['quotation_details', name, 'alloy'],
                                    value,
                                  )
                                }
                                onSearch={handleSearchAlloy}
                                allowClear
                                showSearch={true}
                                filterOption={(input, option) => {
                                  if (!input) return true;
                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  return optionText.includes(inputText);
                                }}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {alloyList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.name} - {el.color_code}
                                  </Option>
                                ))}
                                {alloyLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'temper']}
                              label="Temper"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select temper',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Temper"
                                loading={temperLoading}
                                onPopupScroll={onScrollTemper}
                                value={
                                  form.getFieldValue([
                                    'quotation_details',
                                    name,
                                    'temper',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'temper',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  form.setFieldValue(
                                    ['quotation_details', name, 'temper'],
                                    value,
                                  )
                                }
                                filterOption={(input, option) => {
                                  if (!input) return true;
                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  return optionText.includes(inputText);
                                }}
                                onSearch={handleSearchTemer}
                                allowClear
                                showSearch={true}
                                notFoundContent={
                                  temperLoading ? 'Loading...' : 'No options'
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {temperList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.name} - {el.code}
                                  </Option>
                                ))}
                                {temperLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'length']}
                              label="Length (mm)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter length',
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 7,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                }),
                              ]}
                            >
                              <Input
                                placeholder="0"
                                onChange={() => {
                                  setTimeout(
                                    () => handleFieldChange(index, 'length'),
                                    0,
                                  );
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'pieces']}
                              label="Pieces"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter pieces',
                                },
                                {
                                  pattern: /^\d{1,6}$/,
                                  message:
                                    'Please enter a number with up to 6 digits',
                                },
                              ]}
                            >
                              <Input
                                placeholder="0"
                                onChange={() => {
                                  setTimeout(
                                    () => handleFieldChange(index, 'pieces'),
                                    0,
                                  );
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'net_weight']}
                              label="Net Weight (kg)"
                              rules={[
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 7,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                }),
                              ]}
                            >
                              <Input
                                placeholder="0.0"
                                onChange={e => {
                                  let value = e.target.value;
                                  if (
                                    /^\d{0,8}(\.\d{1,3})?$/.test(value) ||
                                    value === ''
                                  ) {
                                    handleFieldChange(
                                      index,
                                      'net_weight',
                                      value,
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'unit_of_measurement']}
                              label="UOM"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select a measurement unit',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select UOM"
                                showSearch={true}
                                value={searchUnitOfMeasurement}
                                onChange={handleChangeUnitOfMeasurement}
                                onSearch={handleSearchUnitOfMeasurement}
                                allowClear
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                <Option value="Kg">Kg</Option>
                                <Option value="Piece">Piece</Option>
                                <Option value="RMT">RMT</Option>
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'price_per_kg']}
                              label="Price per kg"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Price per kg',
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 7,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                  allowZero: true,
                                }),
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'conversion']}
                              label="Conversion"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Conversion',
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 10,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                  allowZero: true,
                                }),
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>

                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'jobworks']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select temper',
                                },
                              ]}
                              label="JobWork/Value Addition"
                            >
                              <AutoOpenSelect
                                placeholder="Select jobwork"
                                mode="multiple"
                                onChange={value => {
                                  form.setFieldValue(['quotation_details', name, 'jobworks'], value);
                                  handleJobWorkChange(value, name)
                                }}
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                value={form.getFieldValue(['quotation_details', name, 'jobworks'])}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {jobWorklist?.map(item => (
                                  <Option key={item.id} value={item.id}>
                                    {item.name}
                                  </Option>
                                ))}
                              </AutoOpenSelect>
                              {selectedJobWork[name] &&
                                selectedJobWork[name].includes(
                                  'Engineering',
                                ) && (
                                  <Space>
                                    <Form.Item
                                      name={[name, 'cutting']}
                                      valuePropName="checked"
                                      style={{ margin: '0' }}
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'cutting',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        Cutting
                                      </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                      name={[name, 'machinings']}
                                      valuePropName="checked"
                                      style={{ margin: '0' }}
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'machinings',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        Machining
                                      </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                      name={[name, 'deburring']}
                                      valuePropName="checked"
                                      style={{ margin: '0' }}
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'deburring',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        Deburring
                                      </Checkbox>
                                    </Form.Item>
                                  </Space>
                                )}

                              {selectedJobWork[name] &&
                                selectedJobWork[name].includes(
                                  'Surface treatment',
                                ) && (
                                  <Space>
                                    <Form.Item
                                      style={{ margin: '0' }}
                                      name={[name, 'anodising']}
                                      valuePropName="checked"
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'anodising',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        Anodising
                                      </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                      style={{ margin: '0' }}
                                      name={[name, 'powder_coating']}
                                      valuePropName="checked"
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'powder_coating',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        Powder coating
                                      </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                      style={{ margin: '0' }}
                                      name={[name, 'pvdf']}
                                      valuePropName="checked"
                                    >
                                      <Checkbox
                                        style={{ marginTop: '8px' }}
                                        onChange={e =>
                                          handleCheckboxJobWorkChange(
                                            'pvdf',
                                            e.target.checked,
                                            name,
                                          )
                                        }
                                      >
                                        PVDF
                                      </Checkbox>
                                    </Form.Item>
                                  </Space>
                                )}
                            </Form.Item>
                          </Col>
                          {selectedSurfaceFinish[name] &&
                            selectedSurfaceFinish[name]?.includes(
                              'anodising',
                            ) && (
                              <>
                                <Col>
                                  <Form.Item
                                    name={[name, 'anodising_description']}
                                    label="Anodising Description"
                                  >
                                    <Input placeholder="Enter Description" />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'anodising_price']}
                                    label="Anodising Price"
                                    rules={[
                                      createNumberValidationRule({
                                        allowNegative: false,
                                        maxBeforeDecimal: 10,
                                        maxAfterDecimal: 3,
                                        allowDecimal: true,
                                        allowZero: true,
                                      }),
                                    ]}
                                  >
                                    <Input placeholder="0.0" />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                          {selectedSurfaceFinish[name] &&
                            selectedSurfaceFinish[name]?.includes(
                              'powder_coating',
                            ) && (
                              <>
                                <Col>
                                  <Form.Item
                                    name={[name, 'powder_coating_description']}
                                    label="Powder Coating Description"
                                  >
                                    <Input placeholder="Enter Description" />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'powder_coating_price']}
                                    label="Powder Coating Price"
                                    rules={[
                                      createNumberValidationRule({
                                        allowNegative: false,
                                        maxBeforeDecimal: 10,
                                        maxAfterDecimal: 3,
                                        allowDecimal: true,
                                        allowZero: true,
                                      }),
                                    ]}
                                  >
                                    <Input placeholder="0.0" />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                          {selectedSurfaceFinish[name] &&
                            selectedSurfaceFinish[name]?.includes('pvdf') && (
                              <>
                                <Col>
                                  <Form.Item
                                    name={[name, 'pvdf_description']}
                                    label="pvdf Description"
                                  >
                                    <Input placeholder="Enter Description" />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'pvdf_price']}
                                    label="pvdf Price"
                                    rules={[
                                      createNumberValidationRule({
                                        allowNegative: false,
                                        maxBeforeDecimal: 10,
                                        maxAfterDecimal: 3,
                                        allowDecimal: true,
                                        allowZero: true,
                                      }),
                                    ]}
                                  >
                                    <Input placeholder="0.0" />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                          {selectedEngineeringOptions[name]?.includes(
                            'cutting',
                          ) && (
                              <Col>
                                <Form.Item
                                  name={[name, 'cutting_price']}
                                  label="Cutting Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 10,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="Enter Cutting Price" />
                                </Form.Item>
                              </Col>
                            )}
                          {selectedEngineeringOptions[name]?.includes(
                            'machinings',
                          ) && (
                              <Col>
                                <Form.Item
                                  name={[name, 'machinings_price']}
                                  label="Machining Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 10,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="Enter Machining Price" />
                                </Form.Item>
                              </Col>
                            )}
                          {selectedEngineeringOptions[name]?.includes(
                            'deburring',
                          ) && (
                              <Col>
                                <Form.Item
                                  name={[name, 'deburring_price']}
                                  label="Deburring Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 10,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="Enter Deburring Price" />
                                </Form.Item>
                              </Col>
                            )}
                          {selectedJobWork[name] &&
                            selectedJobWork[name].includes('Laser marking') && (
                              <>
                                <Col>
                                  <Form.Item
                                    name={[name, 'laser_marking_description']}
                                    label="Laser Marketing Description"
                                  >
                                    <Input placeholder="Enter Laser marking Description" />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Form.Item
                                    name={[name, 'laser_marking_price']}
                                    label="Laser Making Price"
                                  >
                                    <Input placeholder="Enter Laser Marking Price" />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                          {selectedJobWork[name] &&
                            selectedJobWork[name].includes('Out Source') && (
                              <Col>
                                <Form.Item
                                  name={[name, 'out_source']}
                                  label="Out Source"
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        'Please select if out source is Yes or No',
                                    },
                                  ]}
                                >
                                  <AutoOpenSelect
                                    placeholder="Select Out Source"
                                    onChange={value => {
                                      form.setFieldsValue({
                                        quotation_details: {
                                          ...form.getFieldValue(
                                            'quotation_details',
                                          ),
                                          [name]: {
                                            ...form.getFieldValue([
                                              'quotation_details',
                                              name,
                                            ]),
                                            out_source: value, // Store boolean true/false
                                          },
                                        },
                                      });
                                    }}
                                  >
                                    <Option value={true}>Yes</Option>
                                    <Option value={false}>No</Option>
                                  </AutoOpenSelect>
                                </Form.Item>
                              </Col>
                            )}
                          <div className="addwrp">
                            {index !== 0 && (
                              <Button
                                type="primary"
                                danger
                                icon={<MinusCircleOutlined />}
                                onClick={() => remove(name)}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginTop: '30px',
                                }}
                              />
                            )}
                          </div>
                        </Row>
                      </Col>
                    </Row>
                  ))}
                  <Form.Item>
                    <div className="w-100 flex justify-end">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 500) {
                            dispatch(resetDieProfileData());
                            dispatch(
                              fetchDieProfileDropdown({ page: 1, pagesize: 100 }),
                            );
                            setSearchDieProfile('');
                            add({ price_per_kg: pricePerKg });
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Item
                      </Button>
                    </div>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item
                name="terms_and_condition"
                label="Terms & Condition"
                rules={[
                  { required: true, message: 'Terms & Condition is required' },
                ]}
                valuePropName="content"
              >
                <ReactQuill
                  value={editorValue}
                  onChange={handleChange}
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ header: '1' }, { header: '2' }, { font: [] }],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      ['bold', 'italic', 'underline'],
                      [{ align: [] }],
                      ['link', 'image'],
                      ['blockquote', 'code-block'],
                    ],
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="remarks" label="Remarks">
                <Input.TextArea
                  placeholder="Enter Remarks"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ remarks: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
              loading={btnLoading}
              disabled={hasErrors}
            >
              Create Quotation
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}
